export const keysOf = Object.keys as <T>(obj: T) => (keyof T)[];
